export default [
    { name: "firstname", label: "Imię", type: "text" as const },
    { name: "lastname", label: "Nazwisko", type: "text" as const },
    { name: "email", label: "E-mail", type: "email" as const },
    { name: "phone", label: "Telefon", type: "phone" as const },
]